<template>
  <Notification
    :description="$t('rc_notifications_unavailability', { ConnectivityProvider: providerName })"
    v-bind="$attrs"
  >
  </Notification>
</template>

<script setup>
import { computed } from 'vue'
import Notification from '@/components/productNotifications/Notification.vue'

import { useConnectivityProviderName } from '@/composables/useConnectivityProviderName'

const props = defineProps({
  extraParameters: { type: Object, default: () => ({}) },
})
const { providerName } = useConnectivityProviderName(computed(() => props.extraParameters.partnerId))
</script>
